import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRefs } from 'vue';
import { RelatedAccount } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    relatedAccount: null
  },
  setup(__props: any) {

const props = __props as {
  relatedAccount: RelatedAccount,
}



const { relatedAccount } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_base_label = _resolveComponent("base-label")!
  const _component_account_card_lazy = _resolveComponent("account-card-lazy")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_label, {
      textContent: _toDisplayString(_unref(relatedAccount).relationshipName)
    }, null, 8, ["textContent"]),
    _createVNode(_component_account_card_lazy, {
      name: _unref(relatedAccount).relationshipName,
      address: _unref(relatedAccount).publicKey
    }, null, 8, ["name", "address"])
  ]))
}
}

})